import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import { Text } from '@lmc/ui-kit/src/general'
import { NAMESPACE } from 'locale'

type AdministeredContentProps = {
  record: any
  recordDetails?: any
  type: 'scheduled' | 'prn'
  residentFirstName: string
}

const AdministeredContent = ({
  record,
  recordDetails,
  type,
  residentFirstName
}: AdministeredContentProps) => {
  const { t } = useTranslation(NAMESPACE.EMAR_V2)

  if (!recordDetails) {
    return null
  }

  const medicationName = record.medication?.name || ''
  const dose = record.dose || ''
  const hour = record.hour || ''
  const quantity = recordDetails.quantity || dose

  const description =
    type === 'scheduled'
      ? `For ${residentFirstName}'s ${hour} scheduled meds, ${quantity} tablet ${medicationName} was administered.`
      : `For ${residentFirstName}'s PRN meds, ${quantity} tablet ${medicationName} was administered.`

  return (
    <>
      <Label level={2}>{t('DETAILS')}</Label>
      <Value>{description}</Value>
    </>
  )
}

const Label = styled(Text)`
  color: ${({ theme }) => theme.color.neutral.color5};
  font-weight: 500;
`

const Value = styled(Text)`
  color: ${({ theme }) => theme.color.neutral.color3};
  font-weight: 400;
`

export default AdministeredContent
